import PractitionerDetails from './PractitionerDetails';
export default PractitionerDetails;